/**
 * Minimal class joiner. The project has no conditional-class edge cases that
 * would justify pulling in clsx/tailwind-merge.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}
